module.exports = __webpack_public_path__ + "static/s109_large-0801732ffb51782292d4608f18f2c470.jpg";